import React, { useState, useEffect, Fragment } from "react";
import "antd/dist/antd.css";
import styles from "./Home.module.css";
import {
  Alert,
  Badge,
  Row,
  Col,
  Card,
  Tooltip,
  Space,
  Spin,
  Input,
  Typography,
  Table,
  Select,
  message,
  Tag,
  Modal,
  Form,
  Button,
  Upload,
  DatePicker,
  Checkbox,
  Divider,
} from "antd";
import { CSVLink } from "react-csv";
import {
  CloudDownloadOutlined,
  UploadOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { fetchJsData, researchAuth, researchUI } from "../../api";
import { fieldRules } from "../ResearchUI/HardValues";
const { Text, Link } = Typography;
const { RangePicker } = DatePicker;

let USERNAME = null;
const cardProp = {
  size: "small",
  headStyle: {
    fontSize: "14px",
    lineHeight: "8px",
    minHeight: "20px",
  },
};

export const ResearchAdminSection = ({ role, email }) => {
  USERNAME = email.split("@")[0];

  const defaultCol = [
    {
      title: "App ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
      fixed: "left",
      width: "10%",
      render: (text) => <Link href={"/cciresearch/" + text}>{text}</Link>,
    },
    {
      title: "Name",
      dataIndex: "appname",
      key: "appname",
      sorter: (a, b) => (a.appname ? a.appname.localeCompare(b.appname) : 1),
      fixed: "left",
      width: "40%",
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      sorter: (a, b) => (a.category ? a.category.localeCompare(b.category) : 1),
      fixed: "left",
      width: "30%",
    },
  ];
  const searchCol = [
    {
      title: "App ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
      render: (text) => <Link href={"/cciresearch/" + text}>{text}</Link>,
      width: "5%",
    },
    {
      title: "Name",
      dataIndex: "appname",
      key: "appname",
      sorter: (a, b) => (a.appname ? a.appname.localeCompare(b.appname) : 1),
      textWrap: "word-break",
      width: "15%",
      render: (text, record) => (
        <Tooltip title={"Application Name: " + record.application_name}>
          {text}
        </Tooltip>
      ),
    },
    {
      title: "URL",
      dataIndex: "url",
      key: "url",
      sorter: (a, b) => (a.url ? a.appname.localeCompare(b.url) : 1),
      width: "35%",
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      sorter: (a, b) => (a.category ? a.category.localeCompare(b.category) : 1),
      width: "15%",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => (a.status ? a.status.localeCompare(b.status) : 1),
      width: "20%",
    },
    {
      title: "Assign To",
      dataIndex: "assign",
      key: "assign",
      width: "10%",
    },
  ];

  const [loading, setLoading] = useState(false);
  const [usrData, setUsrData] = useState({});
  const [trig, setTrig] = useState(false);
  const [resModalLoad, setResModalLoad] = useState(false);
  const [selRes, SetSelRes] = useState({});
  const [addModalVis, setAddModalVis] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableCol, setTableCol] = useState(defaultCol);
  const [searchLoading, setSearchLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const fetUsrAppCount = await fetchJsData({
        type: "fetch",
        qry: "fetUsrAppCount",
        preProcess: false,
      });

      const fetUsrAppAssign = await fetchJsData({
        type: "fetch",
        qry: "fetUsrAppAssign",
        preProcess: false,
        firstVal: "netskopecci@netskope.com",
      });

      setUsrData({
        fetUsrAppCount: fetUsrAppCount["data"],
        fetUsrAppAssign: fetUsrAppAssign["data"],
      });
      setTableData(fetUsrAppAssign["data"]);
      if (fetUsrAppCount) setLoading(false);
    };
    fetchData();
  }, [role]);

  function resModalOnClick(usrName, usrEmail, usrUserName) {
    setResModalLoad(true);
    setTrig(!trig);
    SetSelRes({
      selResName: usrName,
      selResEmail: usrEmail,
      selResUserName: usrUserName,
    });
  }

  function onClickTokenFetch(appid) {
    const fetchData = async () => {
      const fetchSearchData = await researchAuth({
        username: email,
      });
      console.log("Token Generated");
      const url =
        "https://cciresearch.netskope.io/appIndex/welcome/editAppDataTest?id=" +
        appid +
        "&email=" +
        email +
        "&token=" +
        fetchSearchData;
      if (fetchSearchData == 0) {
        console.log("Error in token generation");
        message.error("Something Went Wrong. Error : Token Generate Error.");
      } else {
        const newWindow = window.open(url, "_blank", "noopener");
      }
    };
    fetchData();
  }

  const onAppModalClose = () => {
    setAddModalVis(false);
  };

  const onAppSearch = (searchVal) => {
    const searchData = async () => {
      setSearchLoading(true);
      const result = await fetchJsData({
        type: "fetch",
        qry: "fetSearchApp",
        preProcess: false,
        firstVal: "%" + searchVal + "%",
        secondVal: "%" + searchVal + "%",
        thirdVal: "%" + searchVal + "%",
        fourthVal: "%" + searchVal + "%",
      });
      setTableData(result["data"]);
      setTableCol(searchCol);
      setSearchLoading(false);
    };
    if (searchVal.length > 3) {
      searchData();
    }
  };

  const onAppSearchChange = (e) => {
    if (e.target.value.length == 0) {
      setTableData(usrData["fetUsrAppAssign"]);
      setTableCol(defaultCol);
    }
  };

  const onAppSearchId = (searchVal) => {
    const searchData = () => {
      setSearchLoading(true);
      const result = fetchJsData({
        type: "fetch",
        qry: "fetSearchAppById",
        preProcess: false,
        firstVal: searchVal,
      }).then((result) => {
        setTableData(result["data"]);
        setTableCol(searchCol);
        setSearchLoading(false);
      });
    };
    searchData();
  };

  return (
      <div className="ns-margin-left-large ns-margin-right-large">
          <Row gutter={16} justify="space-between">
              <Col>
                  <Button href="/appadmin">App Admin</Button>
              </Col>
              <Col span={8}>
                  <Card
                      title="Research Team "
                      size="small"
                      extra={
                          <Row>
                              <Col className="gutter-row" span={2}>
                                  {' '}
                                  <div>
                                      {loading ? (
                                          <div>
                                              <Spin size="small" />
                                          </div>
                                      ) : (
                                          <Tooltip placement="topRight" title="Download Status Report" arrowPointAtCenter>
                                              <CSVLink filename={'Status Report.csv'} data={[]} className="btn btn-primary">
                                                  <CloudDownloadOutlined style={{ fontSize: '29px' }} />
                                              </CSVLink>
                                          </Tooltip>
                                      )}
                                  </div>
                              </Col>
                          </Row>
                      }
                      headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                  >
                      <Table
                          rowKey="id"
                          size="small"
                          bordered
                          style={{ margin: '2px', fontSize: '10px' }}
                          dataSource={usrData['fetUsrAppCount']}
                          className={styles.ant_table}
                          columns={[
                              {
                                  title: 'Name',
                                  dataIndex: 'name',
                                  key: 'name',
                                  sorter: (a, b) => (a.name ? a.name.localeCompare(b.name) : 1),
                                  fixed: 'left',
                                  width: '70%',
                                  render: (text, record) => (
                                      <a
                                          className={styles.a_table_tag}
                                          onClick={() => {
                                              resModalOnClick(record.name, record.email, record.username);
                                          }}
                                      >
                                          {text}
                                      </a>
                                  ),
                              },
                              {
                                  title: 'App assigned',
                                  dataIndex: 'appAssigned',
                                  key: 'appAssigned',
                                  sorter: (a, b) => a.appAssigned - b.appAssigned,
                                  fixed: 'left',
                                  width: '30%',
                                  render: (text) => <>{text ? <span>{text}</span> : <span>0</span>}</>,
                              },
                          ]}
                          loading={loading}
                          pagination={false}
                      />
                  </Card>
              </Col>
              <Col>
                  <Button type={'primary'} href="/marketplace">
                      Market Place
                  </Button>
              </Col>
          </Row>
          <Card
              title="Apps in Queue for Research "
              size="small"
              extra={
                  <Row gutter={16} align={'middle'}>
                      <Col>
                          <Input.Search
                              size={'small'}
                              placeholder="Search ID"
                              style={{ width: '150px' }}
                              onSearch={onAppSearchId}
                              onChange={onAppSearchChange}
                              loading={searchLoading}
                          ></Input.Search>
                      </Col>
                      <Col>
                          <Input.Search
                              size={'small'}
                              placeholder="Search Name, URL, Status"
                              style={{ width: '300px' }}
                              onChange={onAppSearchChange}
                              onSearch={onAppSearch}
                              loading={searchLoading}
                          ></Input.Search>
                      </Col>
                      <Col>
                          <Tooltip title={'Add App'}>
                              <PlusOutlined style={{ cursor: 'pointer' }} onClick={() => setAddModalVis(true)} />
                          </Tooltip>
                      </Col>
                      <Col>
                          {' '}
                          <div>
                              {loading ? (
                                  <div>
                                      <Spin size="small" />
                                  </div>
                              ) : (
                                  <Tooltip placement="topRight" title="Download Status Report" arrowPointAtCenter>
                                      <CSVLink filename={'Status Report.csv'} data={[]} className="btn btn-primary">
                                          <CloudDownloadOutlined style={{ fontSize: '29px' }} />
                                      </CSVLink>
                                  </Tooltip>
                              )}
                          </div>
                      </Col>
                  </Row>
              }
              headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
          >
              <Table
                  rowKey="id"
                  size="small"
                  bordered
                  style={{ margin: '2px' }}
                  dataSource={tableData}
                  className={styles.ant_table}
                  columns={tableCol}
                  loading={loading}
                  tableLayout={'fixed'}
                  pagination={{
                      pageSizeOptions: ['10', '30', '60', '100', '1000'],
                      defaultPageSize: '50',
                      showSizeChanger: true,
                  }}
              />
          </Card>
          <ResearcherModal show={resModalLoad} trig={trig} selRes={selRes} actEmail={email}></ResearcherModal>
          <Modal title="App Addition Request" visible={addModalVis} onCancel={onAppModalClose} width={'80%'} destroyOnClose>
              <AddAppModal setModalVis={onAppModalClose} />
          </Modal>
      </div>
  );
};

const AddAppModal = (props) => {
  const tableColumns = [
    { title: "App Name", dataIndex: "req_appName", width: "15%" },
    { title: "URL", dataIndex: "req_url", width: "30%" },
    { title: "Category", dataIndex: "req_category", width: "30%" },
    {
      title: "Status",
      dataIndex: "status",
      width: "10%",
      render: (text, record) => (
        <Tooltip title={new Date(record.createdAt).toUTCString()}>
          {text}
        </Tooltip>
      ),
    },
  ];

  const [loading, setLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [appExistTableData, setAppExistTableData] = useState([]);
  const [addForm] = Form.useForm();

  useEffect(() => {
    const fetchInitData = async () => {
      setLoading(true);
      const result = await researchUI({
        function: "getAllInitData",
      });
      if (result.success == 1) {
        setCategoryList(
          result.data.category.map((cat) => {
            return { label: cat.category_name, value: cat.category_name };
          })
        );
        await fetchPendingReq();
      } else {
        message.error("Something Went Wrong");
      }
    };

    const fetchPendingReq = async () => {
      const result = await researchUI({
        function: "appChanges",
        reqType: "GetReqsByUser",
        requestedBy: USERNAME,
      });
      setTableData(result.data.pending);
      setLoading(false);
    };

    fetchInitData();
  }, []);

  const catSelProp = {
    showSearch: true,
    options: categoryList,
    optionFilterProp: "label",
    filterOption: (input, option) =>
      option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0,
    filterSort: (optionA, optionB) =>
      optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase()),
    style: { width: "300px" },
    size: "small",
  };

  const onAddFormFinish = (values) => {
    const addAppReq = async () => {
      const result = await researchUI({
          function: 'appChanges',
          req_type: 'ADD',
          req_appName: values.add_appName.trim(),
          req_url: values.add_URL,
          req_category: values.add_Category,
          comments: values.add_comments,
          requestedBy: USERNAME,
          status: 'Pending',
          reqType: 'New',
      })
          .then((result) => {
              if (result.success == 1) {
                  console.log(result);
                  message.success('App Addition Request Submitted');
                  setAppExistTableData([]);
                  props.setModalVis();
              } else {
                  setAppExistTableData(result.data.tableData);
                  message.error(result.data.msg);
              }
          })
          .catch(() => message.error('Something Went Wrong.'));
    };
    addAppReq();
  };
  return (
    <>
      {loading ? (
        <Row justify="center" gutter={24}>
          <Col span={1}>
            <Spin tip="Loading..."></Spin>
          </Col>
        </Row>
      ) : (
        <>
          <Row>
            {appExistTableData.length > 0 ? (
              <Col span={24}>
                <Badge.Ribbon text="Exist" color="red">
                  <Card title="Already Exist Apps" size="small">
                    <Table
                      bordered
                      dataSource={appExistTableData}
                      columns={[
                        {
                          title: "App ID",
                          dataIndex: "application_id",
                          render: (text) => (
                            <a target={"_blank"} href={"/cciresearch/" + text}>
                              {text}
                            </a>
                          ),
                        },
                        {
                          title: "Ref Table",
                          dataIndex: "table",
                        },
                        {
                          title: "Data",
                          dataIndex: "data",
                        },
                      ]}
                      pagination={false}
                    ></Table>
                  </Card>
                </Badge.Ribbon>
              </Col>
            ) : (
              ""
            )}
            <Col span={24}>
              <Card title={"New App Addition Request"} {...cardProp}>
                <Form
                  form={addForm}
                  preserve={false}
                  onFinish={onAddFormFinish}
                  size={"small"}
                >
                  <Row gutter={2}>
                    <Col span={8}>
                      <Divider
                        orientation={"left"}
                        className={styles.dividerSmall}
                      >
                        App Name
                      </Divider>
                      <Form.Item name="add_appName" rules={fieldRules.appName}>
                        <Input size={"small"} placeholder={"App Name"} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Divider
                        orientation={"left"}
                        className={styles.dividerSmall}
                      >
                        URL
                      </Divider>
                      <Form.Item name="add_URL" rules={fieldRules.url}>
                        <Input size={"small"} placeholder={"URL"} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Divider
                        orientation={"left"}
                        className={styles.dividerSmall}
                      >
                        Category
                      </Divider>
                      <Form.Item
                        name="add_Category"
                        rules={fieldRules.category}
                      >
                        <Select {...catSelProp}></Select>
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Divider
                        orientation={"left"}
                        className={styles.dividerSmall}
                      >
                        Comment
                      </Divider>
                      <Form.Item name="add_comments">
                        <Input.TextArea
                          placeholder={"Comments"}
                        ></Input.TextArea>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item>
                    <Button htmlType="submit">Submit</Button>
                  </Form.Item>
                </Form>
              </Card>
            </Col>
            <Col span={24}>
              <Table
                bordered
                dataSource={tableData}
                columns={tableColumns}
                pagination={false}
                size={"small"}
              />
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

//Researcher Modal
//OnClick Researcher Name in
const ResearcherModal = (props) => {
  const defaultColumn = [
    {
      title: "AppId",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
      fixed: "left",
      width: "6%",
      render: (text) => <Link href={"/cciresearch/" + text}>{text}</Link>,
    },
    {
      title: "App Name",
      dataIndex: "appname",
      key: "appname",
      sorter: (a, b) => (a.appname ? a.appname.localeCompare(b.appname) : 1),
      fixed: "left",
      width: "40%",
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      sorter: (a, b) => (a.category ? a.category.localeCompare(b.category) : 1),
      fixed: "left",
      width: "30%",
    },
    {
      title: "Research Link",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      width: "24%",
      render: (text) => (
        <Button
          type="link"
          onClick={() => {
            onClickTokenFetch(text);
            return false;
          }}
        >
          Link
        </Button>
      ),
    },
    {
      title: "Hidden Count",
      dataIndex: "hidden_count",
      key: "hidden_count",
      sorter: (a, b) => a.hidden_count - b.hidden_count,
      fixed: "left",
      width: "10%",
    },
  ];

  const appAssignColumn = [
    {
      title: "AppId",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
      fixed: "left",
      width: "6%",
      render: (text) => <Link href={"/cciresearch/" + text}>{text}</Link>,
    },
    {
      title: "App Name",
      dataIndex: "appname",
      key: "appname",
      sorter: (a, b) => (a.appname ? a.appname.localeCompare(b.appname) : 1),
      fixed: "left",
      width: "20%",
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      sorter: (a, b) => (a.category ? a.category.localeCompare(b.category) : 1),
      fixed: "left",
      width: "20%",
    },
    {
      title: "Completion Status",
      dataIndex: "completionStatus",
      key: "completionStatus",
      sorter: (a, b) =>
        a.completionStatus
          ? a.completionStatus.localeCompare(b.completionStatus)
          : 1,
      fixed: "left",
      width: "20%",
    },
    {
      title: "Hidden Count",
      dataIndex: "hidden_count",
      key: "hidden_count",
      sorter: (a, b) => a.hidden_count - b.hidden_count,
      fixed: "left",
      width: "10%",
    },
    {
      title: "Tag",
      dataIndex: "customtag",
      key: "customtag",
      fixed: "left",
      width: "10%",
      render: (text, record) => (
        <>
          {text.includes("custom_p1") ? <Tag color="red">P1</Tag> : ""}
          {text.includes("custom_p2") ? <Tag color="green">P2</Tag> : ""}
          {text.includes("custom_customer") ? (
            <Tag color="blue">Customer</Tag>
          ) : (
            ""
          )}
          {record.error != "" ? <Tag color="yellow">{record.error}</Tag> : ""}
        </>
      ),
    },
  ];

  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [tableColumn, setTableColumn] = useState(defaultColumn);
  const [tableData, setTableData] = useState([]);
  const [resDateRange, setResDateRange] = useState({});
  const [resCompStatus, setResCompStatus] = useState("");
  const [resInputApps, setResInputApps] = useState("");
  const [selUsr, setSelUsr] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [actUsr, setActUsr] = useState("");
  const openModal = () => setShow(props.show);
  const completionStatus = [
    "APP NOT ACTIVE",
    "APP NOT SAAS",
    "APP VERIFIED NOT SAAS",
    "APP NOT IMPORTANT",
    "APP AWAITING RESPONSE",
    "APP MINIMUM COMPLETE",
    "APP MINIMUM COMPLETE PENDING REVIEW",
    "APP ALL COMPLETE",
    "APP ALL COMPLETE PENDING REVIEW",
    "APP ALL COMPLETE PENDING COMMUNICATION",
    "APP NEED DIALOGUE",
    "APP ABOUT AND LOGO DONE",
    "APP ASSIGNED",
    "APP ALL COMPLETE READY FOR REVIEW",
  ];

  useEffect(() => {
    if (props.show === true) {
      setLoading(true);
      openModal();
      setSelUsr(props.selRes["selResEmail"]);
      fetchSearchData(props.selRes["selResEmail"]);
      setUserNameActUsr();
    }
  }, [props.trig]);

  const closeModal = () => {
    setShow(false);
    tableReset();
    setResInputApps("");
    setResDateRange({});
    setResCompStatus("");
    const reload = () => window.location.reload();
    reload();
  };

  function fetchSearchData(usrEmail) {
    const fetchData = async () => {
      const fetchSearch = await fetchJsData({
        type: "fetch",
        qry: "fetUsrAppAssign",
        preProcess: false,
        firstVal: usrEmail,
      });
      setTableColumn(defaultColumn);
      setTableData(fetchSearch["data"]);
      setLoading(false);
    };
    fetchData();
  }

  function fetchAppAssignData(apps) {
    apps = apps.split(",").map((r) => parseInt(r));
    setLoading(true);
    const fetchData = async () => {
      const result = await researchUI({
        function: "getApplicationsById",
        application_ids: apps,
      });
      setTableData(result["data"]);
      setLoading(false);
    };
    fetchData();
  }

  function setUserNameActUsr() {
    const fetchUserNameCall = async () => {
      const fetchUserName = await fetchJsData({
        type: "fetch",
        qry: "fetUserName",
        preProcess: false,
        firstVal: props.actEmail,
      }).then((res) => {
        try {
          setActUsr(res["data"][0]["username"]);
        } catch (e) {
          setActUsr("");
        }
      });
    };
    fetchUserNameCall();
  }

  function tableReset() {
    setTableColumn(defaultColumn);
    setTableData([]);
  }

  function removeFrmTableById() {}
  const handleResDateRange = (range) => {
    if (range != null) {
      const startDate = range[0].format().split("T")[0] + " 00:00:00";
      const endDate = range[1].format().split("T")[0] + " 23:59:59";
      setResDateRange({ startDate: startDate, endDate: endDate });
    }
    if (range == null) {
      setResDateRange(null);
    }
  };

  const handleResCompStatus = (status) => {
    setResCompStatus(status);
  };

  const handleResSearch = () => {
    if (resDateRange != null && resDateRange != "") {
      tableReset();
      setLoading(true);
      const fetchData = async () => {
        const fetchSearchData = await fetchJsData({
          type: "fetch",
          qry: "fetUsrAppDateWise",
          preProcess: false,
          firstVal: selUsr,
          secondVal: resDateRange["startDate"],
          thirdVal: resDateRange["endDate"],
        });
        setLoading(false);
        setTableColumn(appAssignColumn);
        let tableD = fetchSearchData["data"];
        if (resCompStatus != "" && resCompStatus != null) {
          tableD = tableD.filter(function (value, index, arr) {
            return value.completionStatus === resCompStatus;
          });
        }
        setTableData(tableD);
      };
      fetchData();
    } else {
      alert("Select Date Range.");
    }
  };

  const handleResAppAssignInp = () => {
    if (resInputApps != null && resInputApps != "") {
      tableReset();
      setTableColumn(appAssignColumn);
      fetchAppAssignData(resInputApps);
    }
  };

  const handleResAppAssignProcess = () => {
    //Empty Check
    if (selectedRowKeys != null) {
      //Fetch assign_to usename from SI.users
      if (actUsr == "") setUserNameActUsr();
      console.log("UserName" + actUsr);
      if (actUsr == "") {
        alert("Something Went Wrong Contact Developer");
        return;
      }
      const appAssignProcess = async () => {
        const result = await researchUI({
          function: "appAssignProcess",
          application_ids: selectedRowKeys,
          assignee: actUsr,
          assignTo: props.selRes["selResUserName"],
        })
          .then((res) => {
            let tableDataId = tableData;
            //On Success Remove From Table Else Update Error
            res.data.map((r) => {
              if (r.error.length > 0) {
                tableDataId = tableDataId.map((e) => {
                  if (r.id === e.id) {
                    e.error = r.error;
                  }
                  return e;
                });
              } else {
                tableDataId = tableDataId.filter((i) => {
                  if (r.id === i.id) return false;
                  return true;
                });
              }
            });
            setTableData([]); //To Reset Table Data
            setTableData(tableDataId);
            setSelectedRowKeys([]);
          })
          .catch((err) => {
            try {
              alert(err.response.data.message);
            } catch (e) {
              alert("Something Went Wrong.");
            }
          });
      };
      appAssignProcess();
    }
  };

  function onClickTokenFetch(appid) {
    const fetchData = async () => {
      const fetchSearchData = await researchAuth({
        username: props.actEmail,
      });
      console.log("Token Generated");
      const url =
        "https://cciresearch.netskope.io/appIndex/welcome/editAppDataTest?id=" +
        appid +
        "&email=" +
        props.actEmail +
        "&token=" +
        fetchSearchData;
      if (fetchSearchData == 0) {
        console.log("Error in token generation");
        message.error("Something Went Wrong. Error : Token Generate Error.");
      } else {
        const newWindow = window.open(url, "_blank", "noopener");
      }
    };
    fetchData();
  }

  return (
    <>
      <Modal
        title={"Researcher Panel -> " + props.selRes["selResName"]}
        visible={show}
        onCancel={closeModal}
        width={"90%"}
        bodyStyle={{ padding: "1%" }}
        maskClosable={false}
        footer={null}
      >
        <Row>
          {/* Search Apps */}
          <Col span={12}>
            <Card size="small" title="Search">
              <Form layout="inline">
                <Form.Item>
                  <RangePicker size="small" onChange={handleResDateRange} />
                </Form.Item>
                <Form.Item style={{ minWidth: "40%", maxWidth: "50%" }}>
                  <Select
                    size="small"
                    placeholder="Select Status"
                    onChange={handleResCompStatus}
                    allowClear
                  >
                    <Select.Option value="">Select Status</Select.Option>
                    {completionStatus.map((item) => (
                      <Select.Option
                        style={{ fontSize: "12px" }}
                        key={item}
                        value={item}
                      >
                        {item}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item style={{ marginLeft: "1%" }}>
                  <Button size="small" onClick={handleResSearch}>
                    Search
                  </Button>
                </Form.Item>
                <Form.Item style={{ marginLeft: "1%" }}>
                  <Button
                    size="small"
                    onClick={() => {
                      fetchSearchData(props.selRes["selResEmail"]);
                    }}
                  >
                    Reset
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Col>
          {/* Spacer */}
          <Col span={1}></Col>
          {/* Assign App */}
          <Col span={11}>
            <Card size="small" title="Assign Apps">
              <Form layout="inline">
                <Form.Item>
                  <Upload>
                    <Button
                      style={{ display: "none" }}
                      icon={<UploadOutlined />}
                    >
                      Click to Upload
                    </Button>
                  </Upload>
                </Form.Item>
                <Form.Item>
                  <Input
                    type="text"
                    onChange={(e) => {
                      setResInputApps(e.target.value);
                    }}
                    value={resInputApps}
                    allowClear
                  ></Input>
                </Form.Item>
                <Form.Item>
                  <Button onClick={handleResAppAssignInp}>Fetch</Button>
                </Form.Item>
                <Form.Item>
                  <Button onClick={handleResAppAssignProcess}>Assign</Button>
                </Form.Item>
              </Form>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Table
              rowSelection={{
                type: "checkbox",
                selectedRowKeys,
                onChange: (e) => {
                  setSelectedRowKeys(e);
                },
              }}
              rowKey="id"
              size="small"
              bordered
              scroll={{ x: 400, y: 900 }}
              style={{ margin: "2px" }}
              dataSource={tableData}
              className={styles.ant_table}
              columns={tableColumn}
              loading={loading}
              pagination={{
                pageSizeOptions: ["10", "30", "60", "100", "1000"],
                defaultPageSize: "50",
                showSizeChanger: true,
                position: ["bottomCenter"],
                size: "small",
              }}
            ></Table>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default ResearchAdminSection;
